import url from 'url';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import get from 'lodash/get';

import parse from 'src/common/utils/queryString/parse';
import { BaseLoader } from '../Loader';
import hasNeverSubscribedOnWeb from '../../utils/subscription/hasNeverSubscribedOnWeb';
import hasSubscribed from '../../utils/subscription/hasSubscribed';
import getLoginRedirect from '../../utils/auth/getLoginRedirect';
import getCouponRedirect from '../../utils/subscription/getCouponRedirect';
import {
  currentSubscriptionStatus,
  premiumSubscriptionStatus,
} from '../../utils/subscription/subscriptionStatus';
import { PAYMENT_PATH, SUBSCRIBE_PATH } from '../../constants/paths';
import { PAYMENT_FLOW } from '../../constants/subscription/flow';
import { selectSubscriptionStatus } from '../../selectors/me';
import RenewLoader from './RenewLoader';

// exported for unit testing
export class RenewRoute extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    subscription: PropTypes.object.isRequired,
    me: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const routeTo = this.determineRoute();
    if (routeTo) {
      this.props.history.replace(routeTo);
    }
    this.state = { routeTo };
  }

  determineRoute() {
    const { auth, me, subscription, location } = this.props;

    const loginRedirect = getLoginRedirect(auth, location, PAYMENT_FLOW);
    if (loginRedirect) {
      return url.format(loginRedirect);
    }

    const couponRedirect = getCouponRedirect(me, location);
    if (couponRedirect) {
      return url.format(couponRedirect);
    }

    const query = parse(get(location, 'search', ''));
    if (hasNeverSubscribedOnWeb(me)) {
      return url.format({
        pathname: SUBSCRIBE_PATH,
        query,
      });
    }

    const premiumStatus = selectSubscriptionStatus({ me });
    const isNotExpiredPremium =
      premiumStatus !== premiumSubscriptionStatus.expired;
    const currentStatus = get(subscription, 'current.status');

    const isNotCanceledOrExpired =
      // Adding this so that renew doesn't redirect on the server side
      currentStatus &&
      currentStatus !== currentSubscriptionStatus.canceled &&
      currentStatus !== currentSubscriptionStatus.expired &&
      isNotExpiredPremium;

    if (hasSubscribed(me.details) && isNotCanceledOrExpired) {
      return PAYMENT_PATH;
    }

    return null;
  }

  render() {
    return this.state.routeTo ? (
      <BaseLoader />
    ) : (
      <RenewLoader {...this.props} />
    );
  }
}

function mapStateToProps(state) {
  const { auth, me, subscription } = state;
  return { auth, me, subscription };
}

export default connect(mapStateToProps)(RenewRoute);
